<template lang="pug">
  div(v-if="lecture && trainee" @click="onCard").wrap-item-trainer-report-card.py10
    div.card-content
      span.card-title {{lecture.title}}
      div.f.fm.mt6
        div.wrap-report-info.f.fm.mr12
          div.wrap-check-icon.f.fm.pb1
            v-icon(v-if="content && content.status == 'pass'" color='blue' size='20px').mr2 check_circle
            v-icon(v-if="content && content.status == 'fail'" color='red' size='20px').mr2 remove_circle
          span(v-if="content && content.status == 'reviewing'") レヴュー待ち
          span(v-if="content && content.status == 'pass'") 合格
          span(v-if="content && content.status == 'fail'") 再提出
        div.f.fm
          v-avatar(size="20px").mr8
            img(:src="trainee.iconURL")
          span {{trainee.name}}
</template>

<style lang="scss" scoped>
.wrap-item-trainer-report-card {
  border-bottom: solid 0.8px rgba(0, 0, 0, 0.6);
  .card-content {
    width: 93%;
    max-width: 420px;
    margin: 0 auto;
    .card-title {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import { database } from '@shared/database'

export default {
  components: {
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      course: null,
      lecture: null,
      trainee: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    // this.course = await db.collection('COURSES')
    //   .doc(this.content.course)
    //   .get()
    //   .then(d =>  {
    //     return d.data()
    //   })
    this.course = await database.getCourse(this.content.course)
    this.lecture = this.course.lectures[Number(this.content.lectureIndex)]
    // this.trainee = await db.collection('USERS')
    //   .doc(this.content.createdBy)
    //   .get()
    //   .then(d => { return d.data() })
    this.trainee = await database.getTrainee(this.content.createdBy)
  },
  methods: {
    onCard () {
      this.$router.push(`/trainer/report_list/${this.content.createdBy}/${this.content.course}/${this.content.lectureIndex}`)
    }
  }
}
</script>
